import { type Node } from '@xyflow/react'
import type { IFlowAction } from 'widgets/Flow'

export const getInitialNode = <T extends string>(
  action: IFlowAction<T>
): Node<Record<string, string>, string> => ({
  id: action.actionStore.id,
  position: { x: 0, y: 0 },
  type: action.actionStore.type,
  draggable: false,
  data: {},
})
